import React, { useContext, useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import DropdownList from 'react-widgets/DropdownList';
import { Multiselect } from 'react-widgets';
import ReportComponent from '../../../../utils/ReportComponent/ReportComponent';
import DynamicSelectSegment from '../../../DynamicSelectSegment';
import Custom from '../../../Multiselects/Custom';
import Default from '../../../Multiselects/Default';
import Button from '../../../Button';
import { I18nContext } from 'utils/I18n/context';

const components = { Custom, Default, DynamicSelectSegment };

const StatisticsSegmentsItem = (props) => {
    const { t } = useContext(I18nContext) || {};
    
    const getTypeMultiselect = useCallback((segment) => {
        const metricParams = ReportComponent.getParams({ key: segment, metricKey: 'GroupBy' }) || {};
        if (metricParams.format === 'ids') return 'DynamicSelectSegment';
        if (metricParams.values) return 'Default';
        return 'Custom';
    }, []);

    const [state, setState] = useState({
        segment: props.segment,
        exclusive: props.exclusive,
        values: props.values,
        typeMultiselect: getTypeMultiselect(props.segment)
    });

    useEffect(() => {
        const isChangeSegment = props.segment !== state.segment;
        setState(prev => ({
            ...prev,
            segment: props.segment,
            exclusive: props.exclusive,
            values: isChangeSegment ? props.values : prev.values,
            typeMultiselect: getTypeMultiselect(props.segment)
        }));
    }, [props.segment, props.exclusive, props.values, getTypeMultiselect]);

    const onChange = useCallback(() => {
        setState(currentState => {
            props.onChangeSegment({
                segment: currentState.segment,
                exclusive: currentState.exclusive,
                values: (currentState.values || []).map((item) => item.value)
            }, props.index);
            return currentState;
        });
    }, [props]);

    const onChangeSegment = useCallback((item) => {
        const nextSegmentKey = item && item.value ? item.value : '';
        setState(prev => ({
            ...prev,
            segment: nextSegmentKey,
            values: [],
            exclusive: false,
            typeMultiselect: getTypeMultiselect(nextSegmentKey)
        }));
        onChange();
    }, [getTypeMultiselect, onChange]);

    const onExclusiveChange = useCallback((item) => {
        const isExclude = !!(item && item.value === 'exclude');
        setState(prev => ({ ...prev, exclusive: isExclude }));
        onChange();
    }, [onChange]);

    const onChangeValues = useCallback((value) => {
        setState(prev => ({ ...prev, values: value }));
        onChange();
    }, [onChange]);

    const onDelete = useCallback(() => props.onDelete(props.index), [props]);
    const onApply = useCallback(() => props.onUpdateDate(props.index), [props]);

    const getGroupParamsSegment = useCallback(() => {
        const params = t?.statistics?.groupParamsSegment || {};
        let listParamsSegment = [];
        Object.keys(params).forEach(function(key) {
            listParamsSegment.push({ title: params[key], value: key });
        });
        return listParamsSegment;
    }, [t]);

    const groupParamsSegment = getGroupParamsSegment();
    const filteredParams = (groupParamsSegment || []).filter(opt => {
        // allow currently selected value; block values already chosen in other rows
        if (opt.value === state.segment) return true;
        if (!opt.value) return true;
        const selected = props.selectedSegments || [];
        return selected.indexOf(opt.value) === -1;
    });
    const staticNames = t?.reportPage || {};
    const staticActions = t?.actions || {};
    const Multiselector = components[state.typeMultiselect] || Custom;

    return (
        <div className="row flex-lg-nowrap flex-wrap">
            <div className="table-filter__item">
                <label className="input-label"> {props.segment ? staticNames.filter : staticNames.addFilter} </label>
                    <DropdownList
                        className={'rw-dropdownlist-select'}
                        dataKey='value'
                        textField='title'
                        data={filteredParams}
                        value={filteredParams.find(o => o.value === state.segment) || null}
                        placeholder={staticNames.selectFilter}
                        disabled={false}
                        onChange={onChangeSegment}
                    />
                </div>

                <div className="table-filter__item custom-input">
                    <label className="input-label"> {staticNames.addMeaning} </label>
                    {state.segment
                        ? (
                            state.typeMultiselect === 'DynamicSelectSegment'
                                ? <DynamicSelectSegment segment={state.segment} values={state.values} multiselect={true} onAction={onChangeValues} />
                                : <Multiselector segment={state.segment} values={state.values} onChange={onChangeValues} />
                        )
                        : <Multiselect disabled={true} />
                    }
                </div>

                <div className="table-filter__item table-filter__item2x">
                    <label className="input-label"> {staticNames.meaning} </label>
                    <DropdownList
                        className={'rw-dropdownlist-select'}
                        dataKey='value'
                        textField='title'
                        data={[
                            { title: staticNames.excludeSegmentTitle, value: 'exclude' },
                            { title: staticNames.includeSegmentTitle, value: 'include' }
                        ]}
                        value={{ title: state.exclusive ? staticNames.excludeSegmentTitle : staticNames.includeSegmentTitle, value: state.exclusive ? 'exclude' : 'include' }}
                        placeholder={state.exclusive ? staticNames.excludeSegment : staticNames.includeSegment}
                        onChange={onExclusiveChange}
                        disabled={!props.segment}
                    />
                </div>

                <div className="statistics__btn-wrap">
                    <Button extraClass={{'apply-btn': true}} loading={props.loading} text={staticActions.apply} onClick={onApply} />
                    <Button extraClass={{'reset-btn': true}} disabled={!state.segment} text={staticActions.reset} onClick={onDelete} />
                </div>
            </div>
    );
};

StatisticsSegmentsItem.propTypes = { values: PropTypes.array };
StatisticsSegmentsItem.defaultProps = { values: [] };

export default StatisticsSegmentsItem;